export default {
  mapsBaseURL: 'https://maps.googleapis.com/maps/api',
  mapsApiKey: process.env.GOOGLE_CLOUD_API_MAPS_KEY,
};
